import React, { useState, createContext, useContext, useMemo } from 'react';

export interface RoomDataInterface {
  roomName: string;
  appointment_id: number | null;
  call_type: string;
}

export interface RoomDataContextInterface {
  roomData: RoomDataInterface;
  setRoomData: React.Dispatch<React.SetStateAction<RoomDataInterface>>;
}

export const RoomData = createContext<RoomDataContextInterface>(null!);

export function useRoomData() {
  return useContext(RoomData);
}

export const RoomDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [roomData, setRoomData] = useState<RoomDataInterface>({
    roomName: '',
    appointment_id: null,
    call_type: ''
  });

  const value = useMemo(() => ({ roomData, setRoomData }), [roomData]);

  return <RoomData.Provider value={value}>{children}</RoomData.Provider>;
};
